import {
  ContentBlock,
  FieldID,
  GuideTypes,
  IntroHeader,
  Metadata,
} from "../models";
import { Entry } from "contentful";
import { convertToHtmlString, findContent } from "../utils";
import { UserContextValues } from "../types";

export const createIntroHeader = (
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
  userContextValues?: UserContextValues,
): IntroHeader => {
  const title = findContent(
    entries,
    FieldID.guideContainer.introHeader.title,
    guideType,
  );
  const subtext = findContent(
    entries,
    FieldID.guideContainer.introHeader.subtext,
    guideType,
  );
  const nextStepText = findContent(
    entries,
    FieldID.guideContainer.introHeader.nextStepText,
    guideType,
  );

  return {
    title: convertToHtmlString(title?.fields.richContent, userContextValues),
    subtext: convertToHtmlString(
      subtext?.fields.richContent,
      userContextValues,
    ),
    nextStepText: convertToHtmlString(
      nextStepText?.fields.richContent,
      userContextValues,
    ),
    fieldMapping: {
      title: FieldID.guideContainer.introHeader.title,
      subtext: FieldID.guideContainer.introHeader.subtext,
      nextStepText: FieldID.guideContainer.introHeader.nextStepText,
    },
  };
};
